import React from 'react';

import SearchTeaser from '../../../components/SearchTeaser';
import BasicPageDetail from './Detail';

const NodeBasicPage = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'search_teaser':
      return <SearchTeaser entity={entity} />;
    case 'full':
    default:
      return <BasicPageDetail entity={entity} />;
  }
};

export default NodeBasicPage;
